import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@aifs-shared/user/user.service';
import { BookmarkService } from './bookmark.service';
import { Bookmark } from './bookmark';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter } from 'rxjs/operators';
import { EventMessage, EventType } from '@azure/msal-browser';
import { ApplicantService } from '../applicant/applicant.service';
import { RoundImageDisplayComponent } from '@aifs-shared/upload/round-image-display.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-bookmark-display',
    templateUrl: './bookmark-display.component.html',
    styleUrls: ['./style/bookmark-display.component.scss'],
    imports: [CommonModule, RoundImageDisplayComponent]
})
export class BookmarkDisplayComponent implements OnInit {
    @Input() showHeading = true;

    constructor(
        private router: Router,
        private userService: UserService,
        private appService: ApplicantService,
        private bookmarkService: BookmarkService,
        private msalBroadcastService: MsalBroadcastService) { }

    ngOnInit(): void {
        this.getBookmarks();
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
            )
            .subscribe((result: EventMessage) => {
                this.getBookmarks();
            });
    }

    reloadBookmarks(): void {
        this.getBookmarks();
    }

    getBookmarks() {
        if (this.userService.user()) {
            this.isLoading = true;
            const cached: Bookmark[] = [];// this.bookmarkService.getCachedBookmarks();

            if (cached && cached.length > 0) {
                this.bookmarks = cached;
            } else {
                const userId = this.userService.user()!.id;
                this.bookmarkService.getBookmarks(userId)
                    .subscribe({
                        next: (r: Bookmark[]) => {
                            // console.log(`Got ${JSON.stringify(r)}`);
                            this.bookmarks = r;
                            this.isLoading = false;
                        }, error: (error) => {
                            this.isLoading = false;
                            console.error(error);
                        }
                    });
            }
        }
    }

    getBookmarkImage(b: Bookmark): string {
        if (b.imageUri) return b.imageUri;
        return environment.resources.imageNoProfileUrl;
    }

    calculateStatusClass(b: Bookmark) {
        return this.appService.getStateDisplayClass(b.state);
    }

    viewBookmark(roleId: number, roleType: string) {
        //console.log(`Show ${roleId}, ${roleType}`);
        if (roleType === 'APP') {
            const link = `/applicant/${roleId}`;
            this.router.navigate([]).then(result => { window.open(link, '_blank'); });
            //this.router.navigateByUrl(`/applicant/${roleId}`)
        }
    }

    shouldSpin() {
        return this.isLoading ? "fa-spin" : "";
    }

    isLoading = false;
    bookmarks: Bookmark[] = [];
}
